var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7598,
    y: 32.2354,
    width: 53.1656,
    height: 62.3988,
    rx: 5.41989,
    fill: "#D1D1D1",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0742,
    y: 25.3654,
    width: 53.1656,
    height: 62.3988,
    rx: 5.41989,
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0059 53.1331L48.7234 59.8925",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7458 53.1541L41.9863 59.8717",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5918 53.197L69.3094 59.9563",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3297 53.2182L62.5703 59.9358",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.168 66.8124L63.6396 66.8664",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8635 40.8672C41.8365 40.871 41.8089 40.8654 41.7855 40.8515L37.8203 37.9836C37.7839 37.9593 37.7365 37.9593 37.7001 37.9836L33.735 40.8515C33.6777 40.8847 33.6041 40.865 33.5708 40.8077C33.5596 40.788 33.554 40.7658 33.5547 40.7433V31.322C33.5547 30.6579 34.0927 30.1194 34.7564 30.1194H40.7641C41.4277 30.1194 41.9657 30.6579 41.9657 31.322V40.7312C41.9749 40.797 41.9293 40.8578 41.8635 40.8672Z",
    fill: "#D1D1D1",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.613 90.3104C33.6643 90.3104 37.7592 86.2155 37.7592 81.1642C37.7592 76.1129 33.6643 72.0181 28.613 72.0181C23.5617 72.0181 19.4668 76.1129 19.4668 81.1642C19.4668 86.2155 23.5617 90.3104 28.613 90.3104Z",
    fill: "#EBEBEB",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9438 81.8131C31.6886 82.2094 31.3488 82.5995 30.9268 82.9896C30.2545 83.5809 29.5369 84.1183 28.7799 84.5943L28.6155 84.6973L28.4512 84.5967C27.6881 84.1269 26.9667 83.5883 26.292 82.9823C25.5486 82.2756 25.0345 81.5285 24.8125 80.7544C25.6136 80.1558 26.6895 79.9116 27.655 80.1876C28.3027 80.3729 28.8732 80.7556 29.4485 81.1053C30.0251 81.4561 30.6385 81.7862 31.3096 81.8499C31.5194 81.8696 31.7353 81.8573 31.9438 81.8131Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5409 79.892C32.5409 80.5704 32.3422 81.1997 31.9447 81.8131C31.7361 81.8573 31.5202 81.8696 31.3104 81.8499C30.6394 81.7861 30.026 81.4561 29.4494 81.1052C28.874 80.7556 28.2419 80.9397 27.5942 80.7544C26.6287 80.4784 25.6145 80.1557 24.8134 80.7544C24.7312 80.4698 24.6895 80.1815 24.6895 79.8907C24.6919 78.8516 25.3912 77.9463 26.3873 77.6985C27.2179 77.4911 28.0766 77.7868 28.6152 78.4259C29.0323 77.9279 29.6494 77.631 30.3106 77.631H30.3143C30.9044 77.631 31.4699 77.869 31.887 78.2922C32.3066 78.7167 32.5409 79.2921 32.5409 79.892Z",
    fill: "#F5F5F5",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 37.3582C66.1568 37.3582 71.148 32.3669 71.148 26.2099C71.148 20.0529 66.1568 15.0617 59.9998 15.0617C53.8428 15.0617 48.8516 20.0529 48.8516 26.2099C48.8516 32.3669 53.8428 37.3582 59.9998 37.3582Z",
    fill: "#D1D1D1",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.089 27.1191C64.089 29.4393 62.2584 31.3203 60.0006 31.3203C57.7427 31.3203 55.9121 29.4393 55.9121 27.1191C55.9121 26.0254 56.3208 25.0274 56.989 24.2801L57.1491 24.1108L60.0006 21.0992L62.8722 24.1315L63.0137 24.2801C63.6803 25.0274 64.089 26.0254 64.089 27.1191Z",
    fill: "#A4A4A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7463 58.8217C91.5477 58.8217 95.44 54.9295 95.44 50.1281C95.44 45.3268 91.5477 41.4345 86.7463 41.4345C81.945 41.4345 78.0527 45.3268 78.0527 50.1281C78.0527 54.9295 81.945 58.8217 86.7463 58.8217Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7454 51.4733C88.1192 51.4733 89.2329 50.3596 89.2329 48.9857C89.2329 47.6119 88.1192 46.4982 86.7454 46.4982C85.3715 46.4982 84.2578 47.6119 84.2578 48.9857C84.2578 50.3596 85.3715 51.4733 86.7454 51.4733Z",
    fill: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3919_39866",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 40,
    width: 19,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7444 58.8213C91.5457 58.8213 95.438 54.929 95.438 50.1277C95.438 45.3263 91.5457 41.4341 86.7444 41.4341C81.943 41.4341 78.0508 45.3263 78.0508 50.1277C78.0508 54.929 81.943 58.8213 86.7444 58.8213Z",
    fill: "#E3E4E6",
    stroke: "#8A8E92",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3919_39866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7456 63.3903C90.0363 63.3903 92.704 60.7227 92.704 57.4319C92.704 54.1411 90.0363 51.4734 86.7456 51.4734C83.4548 51.4734 80.7871 54.1411 80.7871 57.4319C80.7871 60.7227 83.4548 63.3903 86.7456 63.3903Z",
    fill: "#A4A4A4"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7337 34.624C20.7337 34.624 15.8629 33.1729 14.4003 38.0223C15.8628 33.173 11.002 31.6889 11.002 31.6889C11.002 31.6889 15.8728 33.1398 17.3354 28.2905C15.8728 33.1398 20.7337 34.624 20.7337 34.624Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.951 78.0327C109.951 78.0327 105.791 82.9128 110.64 87.0749C105.791 82.9127 101.598 87.7643 101.598 87.7643C101.598 87.7643 105.758 82.8842 100.908 78.722C105.758 82.8842 109.951 78.0327 109.951 78.0327Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.6c72c88ecb6f1ae92fc1423013d12a97.svg";
export { ForwardRef as ReactComponent };